const firebaseConfig = {
  apiKey: "AIzaSyC0B3wmHhSiFEzC2jYW2cqs7kAjrlLZnNI",
  authDomain: "retina-2020.firebaseapp.com",
  databaseURL: "https://retina-2021.europe-west1.firebasedatabase.app/",
  projectId: "retina-2020",
  storageBucket: "retina-2020.appspot.com",
  messagingSenderId: "611089942042",
  appId: "1:611089942042:web:0d33139a0bc0cccc8873a3",
  measurementId: "G-9GX6QT8CQT"
};

export default firebaseConfig;
